import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import { BoxValidations } from "@boxes/BoxValidations";
import style from "@styles/pages/flow/boxes/Box.module.scss";
import { memo } from "react";
import ConditionalBaseBox from "../layout/ConditionalBaseBox";
import { ReportFooter } from "../layout/ReportFooter";

export default memo(({ id, data, selected, isConnectable }) => {
  const subline = () => {
    const clickEvent = (e) => {
      e.preventDefault();
      const event = new MouseEvent("dblclick", {
        view: window,
        bubbles: true,
        cancelable: true,
      });
      e.target.parentNode.dispatchEvent(event);
    };
    return (
      <a href={"#"} className={style.subline} onClick={clickEvent}>
        Ver mais
      </a>
    );
  };

  return (
    <ConditionalBaseBox
      id={id}
      selected={selected}
      valid={BoxValidations.validate(BoxTypes.ClimateProfileConditional, data)}
      title={BoxTitles.ClimateProfileConditional}
      isConnectable={isConnectable}
      footer={<ReportFooter id={id} />}
    >
      {subline()}
    </ConditionalBaseBox>
  );
});
